// extracted by mini-css-extract-plugin
export default {"wrapper":"text_wrapper__X6YbR"};